import {httpAviationApim} from "../../utils/aviationAPIMConfig";
import {USStandToStandDown} from "../../model/Unserviceable/IUSStandToStandDown";
import {IValidationResult} from "../../model/errors/IValidationResult";

const getById = async (
    id: string,
    strToken: string = "",
): Promise<IValidationResult<USStandToStandDown>> => {
    const data = await httpAviationApim.post<
        IValidationResult<USStandToStandDown>
    >(`/unserviceable-standtostanddown/get/${id}`, "", {
        headers: {
            Authorization: `Bearer ${strToken}`,
        },
    });

    return data.data;
};

const create = async (
    unserviceableStandToStandDown: USStandToStandDown,
    strToken: string = "",
): Promise<IValidationResult<USStandToStandDown>> => {
    const params = JSON.stringify(unserviceableStandToStandDown);

    const data = await httpAviationApim.post<
        IValidationResult<USStandToStandDown>
    >(`/unserviceable-standtostanddown/create`, params, {
        headers: {
            Authorization: `Bearer ${strToken}`,
        },
    });
    return data.data;
};

const update = async (
    uSStandToStandDown: USStandToStandDown,
    strToken: string = "",
): Promise<IValidationResult<USStandToStandDown>> => {
    const params = JSON.stringify(uSStandToStandDown);

    const data = await httpAviationApim.put<
        IValidationResult<USStandToStandDown>
    >(
        `/unserviceable-standtostanddown/update/${uSStandToStandDown.flightReportId}`,
        params,
        {
            headers: {
                Authorization: `Bearer ${strToken}`,
            },
        },
    );
    return data.data;
};

export const StandToStandDownTimeService = {
    getById,
    create,
    update,
};
